module.exports = __webpack_public_path__ + "img/nav-med.cfb58efa.svg";